import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'

export const SliderProduct = ({ items }) => {
  const swiperRef = useRef(null)

  return (
    <div className="w-full">
      {/* Slider chính */}
      <Swiper
        // modules={[Pagination]}
        slidesPerView={1}
        spaceBetween={0}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        // pagination={{ clickable: true }}
      >
        {items?.arrImage?.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={item?.url}
              alt={items.name}
              className="w-full h-auto object-contain border rounded-lg"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnail bên dưới */}
      <div className="flex gap-2 mt-3 justify-center w-full overflow-x-auto">
        {items?.arrImage?.map((item, index) => (
          <button
            key={index}
            className="w-16 h-16 border rounded overflow-hidden hover:border-blue-500"
            onClick={() => swiperRef.current?.slideTo(index)}
          >
            <img
              src={item?.url}
              alt={`thumb-${index}`}
              className="w-full h-full object-cover "
            />
          </button>
        ))}
      </div>
    </div>
  )
}
